"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _ReviewBody = _interopRequireDefault(require("./ReviewBody"));

var _ReviewerInfo = _interopRequireDefault(require("./ReviewerInfo"));

var _ReviewReplyThread = _interopRequireDefault(require("./ReviewReplyThread"));

var _Review = _interopRequireDefault(require("../../records/Review"));

var _ReviewAxes = require("../../constants/reviews/ReviewAxes");

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls a renderer function to display each one
var DefaultReviewRenderer = function DefaultReviewRenderer(_ref) {
  var review = _ref.review;
  return _react.default.createElement("div", {
    className: "m-top-8"
  }, _react.default.createElement(_Rating.default, {
    rating: review.get('ratings').get(_ReviewAxes.ReviewAxes.OVERALL),
    label: _react.default.createElement(_FormattedDateTime.default, {
      value: review.get('createdAt'),
      format: "ll",
      type: "userTz"
    })
  }), _react.default.createElement(_ReviewBody.default, {
    className: "m-top-4",
    review: review
  }), _react.default.createElement(_ReviewerInfo.default, {
    inline: true,
    review: review
  }), _react.default.createElement(_ReviewReplyThread.default, {
    reply: review.get('reply')
  }));
};

DefaultReviewRenderer.propTypes = {
  review: _propTypes.default.instanceOf(_Review.default).isRequired
};
var _default = DefaultReviewRenderer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/renderers.js
// module id = 427
// module chunks = 209 210 211 212